        <!-- STORAGE LOCATION=========================STORAGE LOCATION=================STORAGE LOCATION===========STORAGE LOCATION -->
        <div class="storage_location tab_content" id="content6" data-tab="6">
          <!-- form FORM====================================FORM FORM=====================FORM -->
          <div class="form_input">
            <div class="top">
              <h2 class="title">Storage Location</h2>
            </div>

            <form [formGroup]="storageLocationForm">
              <div class="input">
                <label for="">File Location</label>
                <select formControlName="FileLocationId" (change)="onCabinetRef($event.target.value)" class="default_input reference-form">
                  <option  *ngFor="let fileLocation of fileLocations"
                  [value]="fileLocation.id">{{ fileLocation.FileLocationName }}</option>
                </select>
              </div>

              <div class="input">
                <label for="">Cabinet/Ref</label>
                <select formControlName="CabinetShelfRefId" (change)="onFilterRack($event.target.value)" class="default_input reference-form">
                  <option *ngFor="let cabinetShelfRef of filterCabinetRefs"
                  [value]="cabinetShelfRef.id">{{ cabinetShelfRef.CabinetShelfRefNo }}</option>
                </select>
              </div>

              <div class="input">
                <label for="">Rack</label>
                <select formControlName="RackTrayRefId" class="default_input reference-form">
                  <option *ngFor="let rackTrayRef of filterRacks"
                  [value]="rackTrayRef.id">{{ rackTrayRef.RackTrayRefNo }}</option>
                </select>
              </div>

              <div class="input">
                <label for="">Asset Location Address</label>
                <input type="text" formControlName="FiscalFileRemarks" class="default_input reference-form" />
              </div>


              <div class="btn_holder">
                <button
                  class="default_primary-button"
                  (click)="addNew(storageLocationForm.value)"
                  type="submit"
                >
                  <ng-container *ngIf="selectedIndex === null">
                    Add &rarr;
                  </ng-container>
                  <ng-container *ngIf="selectedIndex !== null">
                    Update &rarr;
                  </ng-container>
                </button>

                <div class="refresh">
                <button mat-button (click)="onReset()">
                   <i class="material-icons">
                    settings_backup_restore
                    </i>Reset</button>
                </div>
              </div>
            </form>


          </div>

    <cradua-storage-location-table
    [cabinetShelfRefs]="cabinetShelfRefs"
    [rackTrayRefs]="rackTrayRefs"
    [fileLocations]="fileLocations"
    [selectedLandTitle]="selectedLandTitle"
    (emitEdit)="onEdit($event)"
    >
    </cradua-storage-location-table>
        </div>

        <div class="acquisition_submit">
          <button *ngIf="activitySelectedValue === 'readwrite'" class="default_primary-button" (click)="onSubmit()" type="submit">
            Save
          </button>
        </div>
